$(document).ready(function () {
  var openTimeout1, closeTimeout1, openTimeout2, closeTimeout2;

  $("#Details-HeaderMenu-3").attr("open", "open");

  $("#Details-HeaderMenu-3").hover(
    function () {
      clearTimeout(closeTimeout2);
      openTimeout2 = setTimeout(function () {
        $("#Details-HeaderMenu-3").addClass("open");
      }, 200);
    },
    function () {
      clearTimeout(openTimeout2);
      closeTimeout2 = setTimeout(function () {
        $("#Details-HeaderMenu-3").removeClass("open");
      }, 300);
    }
  );



  //  for changing logo
window.addEventListener("scroll", function () {
    var header = document.querySelector(".header");
    if (window.scrollY > header.offsetTop) {
      header.classList.add("sticky");
    } else {
      header.classList.remove("sticky");
    }
  });
  document.addEventListener("DOMContentLoaded", function () {
    var header = document.querySelector(".header");
    // Function to check scroll position and add sticky class
    function checkScroll() {
      if (window.scrollY > 0) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    }

// Initial check in case the page is loaded already scrolled down
    checkScroll();
    // Listen for scroll events
    window.addEventListener("scroll", checkScroll);
  });


var announcementBar = $('.announcement-bar-section');
    var headerHeight = $('header').outerHeight(); // Adjust this selector to your header

    $(window).scroll(function() {
        if ($(this).scrollTop() > headerHeight) {
            announcementBar.addClass('slideDown');
        } else {
            announcementBar.removeClass('slideDown');
        }
    });


  



  // Attach click event listener outside of toggleAccordion function
  $(".blinix-toggle").click(function () {
    if ($(window).width() < 750) {
      // Toggle active class
      $(this).toggleClass("active");
      // Toggle accordion content
      $(this).next("ul.footer-block__details-content").slideToggle();
      // Close other accordions
      $(".blinix-toggle").not(this).removeClass("active");
      $("ul.footer-block__details-content")
        .not($(this).next("ul.footer-block__details-content"))
        .slideUp();
    }
  });
  // Define toggleAccordion function
  function toggleAccordion() {
    if ($(window).width() >= 750) {
      // Remove click event listener when window size is greater than or equal to 750px
      $(".blinix-toggle").off("click");
      $("ul.footer-block__details-content").removeAttr("style"); // Remove inline style for accordion content
    }
  }
  // Initial call to toggleAccordion function after a delay of 2 seconds
  setTimeout(function () {
    toggleAccordion();
  }, 2000);
  // Call toggleAccordion function on window resize
  $(window).resize(function () {
    toggleAccordion();
  });

 
});
